import "./Content3Styles.css"
function Content3Data(props){
return(
    <div className="c-card">
    <div className="c-image">
      <img src={props.cImg2} alt="image"/> 
    </div>
    <h4>{props.heading}</h4>
    <p>{props.text}</p>
</div>
)
}
export default Content3Data